(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-goal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cart-goal-progress')) return;

    const CHECK =
      '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

    class CartGoalProgress extends HTMLElement {
      connectedCallback() {
        this.goal = Math.max(2, Number(this.dataset.goal) || 3);
        this.free = Math.max(1, Number(this.dataset.free) || 1);
        this.repeat = this.dataset.repeat === 'true';
        this.animate = this.dataset.animate === 'true';
        this.type = (this.dataset.type || '').trim().toLowerCase();
        this.count = Number(this.dataset.count) || 0;
        this.messages = {};
        this.querySelectorAll('template[data-msg]').forEach((t) => {
          this.messages[t.dataset.msg] = t.innerHTML.trim();
        });
        this.iconHtml = this.querySelector('template[data-icon]')?.innerHTML.trim() || '';
        this.labelIconHtml = this.querySelector('template[data-label-icon]')?.innerHTML.trim() || '';

        this.onCartUpdate = () => this.refresh();
        document.addEventListener('cart:update', this.onCartUpdate);

        this.observer = new MutationObserver(() => this.mountAll());
        this.observer.observe(document.body, { childList: true, subtree: true });

        this.mountAll();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this.onCartUpdate);
        this.observer?.disconnect();
      }

      async refresh() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          this.count = (cart.items || [])
            .filter((item) => !this.type || (item.product_type || '').trim().toLowerCase() === this.type)
            .reduce((sum, item) => sum + item.quantity, 0);
        } catch (e) {
          /* si falla, conserva el último conteo */
        }
        this.mountAll(true);
      }

      /** Inserta o actualiza la barra en el carrito lateral y en la página de carrito */
      mountAll(force = false) {
        const targets = [];
        document.querySelectorAll('cart-items-component').forEach((component) => {
          const inDrawer = !!component.closest('cart-drawer-component, .cart-drawer');
          if (inDrawer && this.dataset.showDrawer === 'false') return;
          if (!inDrawer && this.dataset.showPage === 'false') return;
          const wrapper = component.querySelector('.cart-items__wrapper');
          if (wrapper && wrapper.querySelector('.cart-form')) targets.push(wrapper);
        });

        targets.forEach((wrapper) => {
          let node = wrapper.querySelector(':scope > .cart-goal');
          if (!node) {
            node = document.createElement('div');
            wrapper.prepend(node);
            force = true;
          }
          if (force || node.dataset.count !== String(this.count)) this.paint(node, this.count);
        });
      }

      fill(text, values) {
        return (text || '')
          .replaceAll('[faltan]', values.missing)
          .replaceAll('[meta]', this.goal)
          .replaceAll('[llevas]', values.count)
          .replaceAll('[gratis]', values.freeTotal)
          .replaceAll('[pagas]', values.count - values.freeTotal);
      }

      state(count) {
        const goal = this.goal;
        const sets = Math.floor(count / goal);
        const remainder = count % goal;
        let filled;
        let complete;
        let freeTotal;
        if (this.repeat) {
          freeTotal = sets * this.free;
          complete = count > 0 && remainder === 0;
          filled = complete ? goal : remainder;
        } else {
          complete = sets > 0;
          freeTotal = complete ? this.free : 0;
          filled = complete ? goal : count;
        }
        const missing = goal - filled;
        let key = missing === 1 ? 'one' : 'many';
        if (complete) key = 'done';
        else if (freeTotal > 0 && this.messages.next) key = 'next';
        const values = { missing, count, freeTotal };
        const pct = Math.round((filled * 100) / goal);
        return { complete, pct, values, message: this.fill(this.messages[key], values) };
      }

      escape(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }

      paint(node, count) {
        const { complete, pct, values, message } = this.state(count);
        node.className = `cart-goal${complete ? ' cart-goal--complete' : ''}${this.animate ? ' cart-goal--animate' : ''}`;
        node.dataset.count = String(count);
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
        node.style.setProperty('--cart-goal-pct', `${pct}%`);

        const top = this.escape(this.fill(this.dataset.topLabel, values));
        const bottom = this.escape(this.fill(this.dataset.goalLabel, values));

        node.innerHTML = `${message ? `<p class="cart-goal__message">${message}</p>` : ''}<div class="cart-goal__meter">${
          top ? `<span class="cart-goal__top">${top}</span>` : ''
        }<div class="cart-goal__row"><div class="cart-goal__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${pct}"><span class="cart-goal__fill"></span></div><span class="cart-goal__dot" aria-hidden="true">${
          complete ? CHECK : this.iconHtml
        }</span></div>${bottom ? `<span class="cart-goal__bottom">${this.labelIconHtml}<span>${bottom}</span></span>` : ''}</div>`;
      }
    }

    customElements.define('cart-goal-progress', CartGoalProgress);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cart-upsell')) return;

    const GIFT_ICON =
      '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="2.5" y="7" width="15" height="4" rx="1"/><path d="M4 11v6h12v-6M10 7v10M10 7c-1.5-3-5-3-5-1s3 1 5 1zm0 0c1.5-3 5-3 5-1s-3 1-5 1z"/></svg>';

    const esc = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    /** Cuántos productos del carrito se usan para pedir sugerencias (Shopify los da del más reciente al más antiguo) */
    const SOURCE_PRODUCTS = 3;

    /** Catálogo de ligas guardado en la sesión para no volver a pedirlo en cada página */
    const CATALOG_KEY = 'h433-upsell-catalog-v1';
    const CATALOG_TTL = 15 * 60 * 1000;

    /** Palabras que marcan el final del nombre del club en el título ("América Local 1994-1995" -> "america") */
    const CLUB_STOP = new Set([
      'local', 'visitante', 'alternativo', 'alternativa', 'tercero', 'tercera', 'tercer', 'portero', 'manga',
      'version', 'dama', 'mujer', 'nino', 'nina', 'infantil', 'mascota', 'aniversario', 'edicion', 'especial',
      'entrenamiento', 'retro', 'home', 'away', 'third', 'jersey', 'playera', 'camiseta',
    ]);
    const norm = (text) =>
      String(text || '')
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .trim();
    const clubOf = (title) => {
      const words = [];
      for (const word of String(title || '').split(/\s+/)) {
        const w = norm(word).replace(/[.,:;]+$/, '');
        if (!w || /^\d/.test(w) || /^[#(]/.test(w) || CLUB_STOP.has(w)) break;
        words.push(w);
      }
      return words.join(' ') || null;
    };
    /** Intercala varias listas: uno de cada una, por turnos */
    const interleave = (lists) => {
      const out = [];
      const longest = Math.max(0, ...lists.map((l) => l.length));
      for (let i = 0; i < longest; i++) lists.forEach((l) => l[i] !== undefined && out.push(l[i]));
      return out;
    };

    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.max = Number(this.dataset.max) || 4;
        this.source = this.dataset.source || 'cart';
        this.intent = this.dataset.intent || 'related';
        this.cartIds = (this.dataset.inCart || '').split(',').filter(Boolean);
        this.inCart = new Set(this.cartIds);
        this.headings = {};
        this.querySelectorAll('template[data-heading]').forEach((t) => {
          this.headings[t.dataset.heading] = t.innerHTML.trim();
        });
        this.listHtml = this.querySelector('template[data-list]')?.innerHTML || '';
        this.recsHtml = '';
        this.recsKey = '';
        this.recsCache = new Map();

        this.onCartUpdate = () => this.refresh();
        document.addEventListener('cart:update', this.onCartUpdate);
        this.observer = new MutationObserver(() => this.mountAll());
        this.observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', this.onClick);

        this.mountAll();
        if (this.source === 'cart') this.loadRecs().then(() => this.mountAll(true));
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this.onCartUpdate);
        document.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
      }

      get root() {
        return window.Shopify?.routes?.root || '/';
      }

      async refresh() {
        const goal = document.querySelector('cart-goal-progress');
        if (goal && typeof goal.refresh === 'function') {
          try {
            await goal.refresh();
          } catch (e) {
            /* sin barra de progreso */
          }
        }
        try {
          const cart = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) =>
            r.json()
          );
          this.cartIds = [...new Set((cart.items || []).map((item) => String(item.product_id)))];
          this.inCart = new Set(this.cartIds);
        } catch (e) {
          /* conserva el estado anterior */
        }
        if (this.source === 'cart') await this.loadRecs();
        this.mountAll(true);
      }

      /** Precio con el formato de la tienda, sin ceros finales (como money_without_trailing_zeros) */
      money(cents) {
        const amount = Number(cents) / 100;
        const text = Number.isInteger(amount)
          ? amount.toLocaleString('es-MX')
          : amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const format = this.dataset.moneyFormat || '${{amount}}';
        return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, text);
      }

      image(url) {
        if (!url) return '';
        const src = url.startsWith('//') ? `https:${url}` : url;
        return `${src}${src.includes('?') ? '&' : '?'}width=160`;
      }

      /** Una fila de sugerencia, igual a las de la colección */
      itemHtml(product) {
        if (!product?.available) return '';
        const variants = (product.variants || []).filter((v) => v.available);
        if (!variants.length) return '';
        const title = esc(product.title);
        const url = esc(product.url || `${this.root}products/${product.handle}`);
        const img = this.image(product.featured_image);
        const price = Math.min(...variants.map((v) => Number(v.price)));
        // Selector con TODAS las tallas; las agotadas aparecen como "— Agotado" y no se pueden elegir
        const firstId = variants[0].id;
        const picker = `<select class="cart-upsell__select" aria-label="Talla de ${title}" data-variant>${(product.variants || [])
          .map((v) => {
            const name = v.title === 'Default Title' ? 'Talla única' : esc(v.title);
            const attrs = `${v.available ? '' : ' disabled'}${v.id === firstId ? ' selected' : ''}`;
            return `<option value="${v.id}"${attrs}>${name}${v.available ? '' : ' — Agotado'}</option>`;
          })
          .join('')}</select>`;
        return `<li class="cart-upsell__item" data-product-id="${product.id}">
          <a class="cart-upsell__media" href="${url}" tabindex="-1">${
            img ? `<img src="${esc(img)}" alt="${title}" loading="lazy" width="160" height="160">` : ''
          }</a>
          <div class="cart-upsell__info">
            <a class="cart-upsell__title" href="${url}">${title}</a>
            <span class="cart-upsell__price">${esc(this.money(price))}</span>
          </div>
          ${picker}
          <button type="button" class="cart-upsell__add" data-add>${esc(this.dataset.buttonLabel || 'Agregar')}</button>
        </li>`;
      }

      async fetchRecs(productId) {
        if (this.recsCache.has(productId)) return this.recsCache.get(productId);
        const request = fetch(
          `${this.root}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=10&intent=${encodeURIComponent(this.intent)}`,
          { headers: { Accept: 'application/json' } }
        )
          .then((r) => (r.ok ? r.json() : { products: [] }))
          .then((data) => data.products || [])
          .catch(() => []);
        this.recsCache.set(productId, request);
        return request;
      }

      /** Convierte un producto de /collections/x/products.json al formato de las recomendaciones */
      fromCollectionJson(p) {
        const variants = (p.variants || []).map((v) => ({
          id: v.id,
          title: v.title,
          available: v.available !== false,
          price: Math.round(parseFloat(v.price) * 100),
        }));
        return {
          id: p.id,
          title: p.title,
          handle: p.handle,
          url: `${this.root}products/${p.handle}`,
          featured_image: p.images?.[0]?.src || '',
          available: variants.some((v) => v.available),
          variants,
        };
      }

      /**
       * Jerseys de cada liga (colección), con su club sacado del título.
       * Se guarda en la sesión 15 min para no pedirlo en cada página.
       */
      loadCatalog() {
        if (this.catalogPromise) return this.catalogPromise;
        const handles = (this.dataset.leagues || '').split(',').filter(Boolean);
        const build = (raw) => {
          const byId = new Map();
          const leagues = new Map();
          raw.forEach(({ handle, products }) => {
            const ids = [];
            products.forEach((p) => {
              if (!byId.has(String(p.id))) byId.set(String(p.id), { product: p, league: handle, club: clubOf(p.title) });
              ids.push(String(p.id));
            });
            leagues.set(handle, ids);
          });
          return { byId, leagues };
        };
        this.catalogPromise = (async () => {
          try {
            const cached = JSON.parse(sessionStorage.getItem(CATALOG_KEY) || 'null');
            if (cached && Date.now() - cached.t < CATALOG_TTL && cached.h === handles.join(',')) return build(cached.raw);
          } catch (e) {
            /* sin sessionStorage */
          }
          const raw = await Promise.all(
            handles.map((handle) =>
              fetch(`${this.root}collections/${encodeURIComponent(handle)}/products.json?limit=250`, {
                headers: { Accept: 'application/json' },
              })
                .then((r) => (r.ok ? r.json() : { products: [] }))
                .then((data) => ({ handle, products: (data.products || []).map((p) => this.fromCollectionJson(p)) }))
                .catch(() => ({ handle, products: [] }))
            )
          );
          try {
            sessionStorage.setItem(CATALOG_KEY, JSON.stringify({ t: Date.now(), h: handles.join(','), raw }));
          } catch (e) {
            /* sin espacio o modo privado */
          }
          return build(raw);
        })();
        return this.catalogPromise;
      }

      /**
       * Por cada jersey del carrito: primero más del mismo club, luego otros equipos de su liga
       * (alternando equipos para que haya variedad).
       */
      async clubLeagueProducts(ids) {
        if (this.dataset.clubFirst === 'false' || !this.dataset.leagues) return [];
        let catalog;
        try {
          catalog = await this.loadCatalog();
        } catch (e) {
          return [];
        }
        const lists = ids.map((id) => {
          const entry = catalog.byId.get(String(id));
          if (!entry) return [];
          const pool = (catalog.leagues.get(entry.league) || [])
            .filter((pid) => !this.inCart.has(pid))
            .map((pid) => catalog.byId.get(pid))
            .filter((e) => e?.product.available);
          const sameClub = entry.club ? pool.filter((e) => e.club === entry.club) : [];
          const byClub = new Map();
          pool
            .filter((e) => !sameClub.includes(e))
            .forEach((e) => {
              const k = e.club || `_${e.product.id}`;
              if (!byClub.has(k)) byClub.set(k, []);
              byClub.get(k).push(e);
            });
          return [...sameClub, ...interleave([...byClub.values()])].map((e) => e.product);
        });
        return interleave(lists);
      }

      /**
       * Sugerencias para los jerseys más recientes del carrito:
       * 1) más del mismo club, 2) otros equipos de la misma liga, 3) recomendaciones de Shopify.
       * La colección de respaldo completa los lugares que falten (en paint()).
       */
      async loadRecs() {
        const ids = this.cartIds.slice(0, SOURCE_PRODUCTS);
        const key = ids.join(',');
        if (key === this.recsKey) return;
        if (!ids.length) {
          this.recsHtml = '';
          this.recsKey = key;
          return;
        }
        const seen = new Set();
        const merged = [];
        const push = (product) => {
          if (product && !seen.has(String(product.id)) && !this.inCart.has(String(product.id))) {
            seen.add(String(product.id));
            merged.push(product);
          }
        };
        (await this.clubLeagueProducts(ids)).forEach(push);
        const usable = () => merged.filter((p) => p.available && p.variants?.some((v) => v.available)).length;
        if (usable() < this.max) {
          const lists = await Promise.all(ids.map((id) => this.fetchRecs(id)));
          interleave(lists).forEach(push);
        }
        this.recsHtml = merged.map((p) => this.itemHtml(p)).join('');
        this.recsKey = key;
      }

      /** Usa el mensaje de la barra de progreso (si existe) para el título */
      heading() {
        const goal = document.querySelector('cart-goal-progress');
        if (goal && typeof goal.state === 'function') {
          const state = goal.state(goal.count);
          if (state.complete) return { html: this.headings.done, complete: true };
          return { html: state.message || this.headings.default, complete: false };
        }
        return { html: this.headings.default, complete: false };
      }

      mountAll(force = false) {
        const targets = [];
        document.querySelectorAll('cart-items-component').forEach((component) => {
          const inDrawer = !!component.closest('cart-drawer-component, .cart-drawer');
          if (inDrawer && this.dataset.showDrawer === 'false') return;
          if (!inDrawer && this.dataset.showPage === 'false') return;
          const wrapper = component.querySelector('.cart-items__wrapper');
          if (wrapper && wrapper.querySelector('.cart-form')) {
            wrapper.dataset.upsellCards = String(inDrawer && this.dataset.drawerLayout !== 'rows');
            targets.push(wrapper);
          }
        });

        const key = `${[...this.inCart].sort().join(',')}|${this.recsKey}`;
        targets.forEach((wrapper) => {
          let node = wrapper.querySelector(':scope > .cart-upsell');
          if (!node) {
            node = document.createElement('div');
            node.className = 'cart-upsell';
            wrapper.append(node);
            force = true;
          }
          const cards = wrapper.dataset.upsellCards === 'true';
          if (node.classList.contains('cart-upsell--cards') !== cards) node.classList.toggle('cart-upsell--cards', cards);
          if (force || node.dataset.key !== key) this.paint(node, key);
        });
      }

      paint(node, key) {
        node.dataset.key = key;
        const holder = document.createElement('ul');
        holder.className = 'cart-upsell__list';
        // Primero las sugerencias según el carrito; la colección de respaldo completa los lugares que falten.
        holder.innerHTML = this.recsHtml + this.listHtml;
        const seen = new Set();
        let shown = 0;
        holder.querySelectorAll('.cart-upsell__item').forEach((item) => {
          const id = item.dataset.productId;
          if (this.inCart.has(id) || seen.has(id) || shown >= this.max) item.remove();
          else {
            seen.add(id);
            shown++;
          }
        });

        const { html: goalHtml, complete } = this.heading();
        // En tarjetas (carrito lateral compacto) no se repite el mensaje de la barra del 3x2
        const html = node.classList.contains('cart-upsell--cards') ? this.headings.default : goalHtml;
        if (!shown || (complete && this.dataset.hideEmpty === 'true')) {
          node.hidden = true;
          node.innerHTML = '';
          return;
        }
        node.hidden = false;
        node.innerHTML = html ? `<p class="cart-upsell__heading">${GIFT_ICON}<span>${html}</span></p>` : '';
        node.appendChild(holder);
      }

      onClick = async (event) => {
        const button = event.target.closest('.cart-upsell [data-add]');
        if (!button || button.getAttribute('aria-busy') === 'true') return;
        const item = button.closest('.cart-upsell__item');
        const variantId = item?.querySelector('[data-variant]')?.value;
        if (!variantId) return;

        button.setAttribute('aria-busy', 'true');
        item.querySelector('.cart-upsell__error')?.remove();

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        try {
          const res = await fetch(`${this.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

          const cart = await fetch(`${this.root}cart.js`).then((r) => r.json());
          const { CartAddEvent } = await import('@theme/events');
          document.dispatchEvent(
            new CartAddEvent({}, 'cart-upsell', {
              source: 'cart-upsell',
              itemCount: cart.item_count,
              sections: data.sections,
            })
          );
        } catch (error) {
          const p = document.createElement('p');
          p.className = 'cart-upsell__error';
          p.textContent = error.message || 'No se pudo agregar. Intenta de nuevo.';
          item.appendChild(p);
          button.removeAttribute('aria-busy');
        }
      };
    }

    customElements.define('cart-upsell', CartUpsell);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h433-cart-compact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('h433-cart-compact')) return;

    class H433CartCompact extends HTMLElement {
      connectedCallback() {
        this.visible = Number(this.dataset.visible) || 3;
        this.sticky = this.dataset.sticky !== 'false';
        this.scheduled = false;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(document.body, { childList: true, subtree: true, characterData: true });
        this.onResize = () => this.schedule();
        window.addEventListener('resize', this.onResize);
        document.addEventListener('click', this.onClick);
        // Desplazar dentro del carrito no genera eventos que suban: se escuchan en captura
        this.onScroll = () => this.updateBar();
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        this.schedule();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.dialogObserver?.disconnect();
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('click', this.onClick);
      }

      schedule() {
        if (this.scheduled) return;
        this.scheduled = true;
        requestAnimationFrame(() => {
          this.scheduled = false;
          this.apply();
        });
      }

      get dialog() {
        return document.querySelector('cart-drawer-component .cart-drawer__dialog');
      }

      apply() {
        const dialog = this.dialog;
        if (!dialog) return;
        this.applyMore(dialog);
        if (this.sticky) this.applyBar(dialog);
      }

      /* "Ver N jerseys más" debajo de la lista */
      applyMore(dialog) {
        const table = dialog.querySelector('.cart-items__table');
        let button = dialog.querySelector('.h433-cc-more');
        const rows = table ? table.querySelectorAll('tbody > tr.cart-items__table-row') : [];
        const hidden = rows.length - this.visible;

        if (!table || hidden <= 0) {
          if (button) button.remove();
          if (!table || rows.length <= this.visible) document.documentElement.classList.remove('h433-cc-expanded');
          return;
        }

        if (!button || button.previousElementSibling !== table) {
          button?.remove();
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'h433-cc-more';
          table.after(button);
        }

        const expanded = document.documentElement.classList.contains('h433-cc-expanded');
        const label = expanded
          ? `${this.dataset.lessLabel || 'Ver menos'} ▴`
          : `${(this.dataset.moreLabel || 'Ver [n] jerseys más').replace('[n]', hidden)} ▾`;
        if (button.textContent !== label) button.textContent = label;
        button.setAttribute('aria-expanded', String(expanded));
      }

      onClick = (event) => {
        const more = event.target.closest('.h433-cc-more');
        if (more) {
          document.documentElement.classList.toggle('h433-cc-expanded');
          this.schedule();
          return;
        }
        const pay = event.target.closest('.h433-cc-bar__pay');
        if (pay) {
          const real = this.dialog?.querySelector('.cart__checkout-button');
          if (real && !real.disabled) real.click();
        }
      };

      /* Barra fija de pago: aparece solo si el botón "Pagar" real no se ve */
      applyBar(dialog) {
        const real = dialog.querySelector('.cart__checkout-button');
        let bar = dialog.querySelector(':scope > .h433-cc-bar');

        if (!real) {
          if (bar) bar.dataset.show = 'false';
          dialog.classList.remove('h433-cc-has-bar');
          return;
        }

        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'h433-cc-bar';
          bar.dataset.show = 'false';
          bar.innerHTML = `<div class="h433-cc-bar__line"><span><span data-cc-label></span> <span class="h433-cc-bar__save" data-cc-save></span></span><span class="h433-cc-bar__total" data-cc-total></span></div><button type="button" class="h433-cc-bar__pay"></button>`;
          dialog.appendChild(bar);
        }

        const total = dialog.querySelector('.cart-totals__total-value')?.textContent.trim() || '';
        const savingsAmount = dialog.querySelector('.h433-savings__amount')?.textContent.replace('!', '').trim() || '';
        const setText = (sel, text) => {
          const el = bar.querySelector(sel);
          if (el && el.textContent !== text) el.textContent = text;
        };
        setText('[data-cc-label]', this.dataset.totalLabel || 'Total');
        setText('[data-cc-total]', total);
        setText('[data-cc-save]', savingsAmount ? `· ${(this.dataset.savingsLabel || 'ahorras [monto]').replace('[monto]', savingsAmount)}` : '');
        setText('.h433-cc-bar__pay', this.dataset.payLabel || 'Pagar pedido');

        // Volver a revisar cuando el carrito se abre o se cierra
        if (this.watchedDialog !== dialog) {
          this.dialogObserver?.disconnect();
          this.watchedDialog = dialog;
          this.dialogObserver = new MutationObserver(() => {
            this.updateBar();
            setTimeout(() => this.updateBar(), 350);
          });
          this.dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
        }
        this.updateBar();
      }

      /** ¿Se ve el botón "Pagar" real dentro de la pantalla del carrito? */
      realButtonVisible(dialog, real) {
        const box = dialog.getBoundingClientRect();
        const btn = real.getBoundingClientRect();
        if (!btn.height) return false;
        let top = box.top;
        let bottom = Math.min(box.bottom, window.innerHeight);
        // Recorte de los contenedores con scroll del carrito
        for (let el = real.parentElement; el && el !== dialog; el = el.parentElement) {
          const style = getComputedStyle(el);
          if (/(auto|scroll|hidden)/.test(style.overflowY)) {
            const r = el.getBoundingClientRect();
            top = Math.max(top, r.top);
            bottom = Math.min(bottom, r.bottom);
          }
        }
        const bar = dialog.querySelector(':scope > .h433-cc-bar');
        if (bar && bar.dataset.show === 'true') bottom = Math.min(bottom, bar.getBoundingClientRect().top);
        const visible = Math.min(btn.bottom, bottom) - Math.max(btn.top, top);
        return visible >= btn.height * 0.6;
      }

      updateBar() {
        const dialog = this.dialog;
        const bar = dialog?.querySelector(':scope > .h433-cc-bar');
        const real = dialog?.querySelector('.cart__checkout-button');
        if (!dialog || !bar || !real) return;
        const show = dialog.open && !this.realButtonVisible(dialog, real);
        const value = show ? 'true' : 'false';
        if (bar.dataset.show !== value) bar.dataset.show = value;
        dialog.classList.toggle('h433-cc-has-bar', show);
        if (show) dialog.style.setProperty('--h433-cc-bar-h', `${bar.offsetHeight + 8}px`);
      }
    }

    customElements.define('h433-cart-compact', H433CartCompact);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h433-cart-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('h433-cart-trust')) return;

    const TZ = 'America/Mexico_City';
    const DAY = 86400000;

    function nowInMexico() {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', {
          timeZone: TZ,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        })
          .formatToParts(new Date())
          .map((p) => [p.type, p.value])
      );
      return {
        date: Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)),
        minutes: Number(parts.hour) * 60 + Number(parts.minute),
      };
    }

    const toMinutes = (text, fallback) => {
      const m = String(text || '').match(/(\d{1,2})(?::(\d{2}))?/);
      if (!m) return fallback;
      return Math.min(23, Number(m[1])) * 60 + Math.min(59, Number(m[2] || 0));
    };
    const iso = (date) => new Date(date).toISOString().slice(0, 10);
    const weekday = (date) => new Date(date).getUTCDay();
    const fmt = (opts) => new Intl.DateTimeFormat('es-MX', { timeZone: 'UTC', ...opts });
    const fmtWeekday = fmt({ weekday: 'long' });
    const fmtMonth = fmt({ month: 'long' });
    const dayName = (date) => `${fmtWeekday.format(new Date(date))} ${new Date(date).getUTCDate()}`;
    const monthName = (date) => fmtMonth.format(new Date(date));

    class H433CartTrust extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.cutoffWeek = toMinutes(d.cutoffWeekday, 17 * 60);
        this.cutoffSat = toMinutes(d.cutoffSaturday, 15 * 60);
        this.shipSaturday = d.shipSaturday !== 'false';
        this.minDays = Math.max(0, Number(d.minDays) || 0);
        this.maxDays = Math.max(this.minDays, Number(d.maxDays) || this.minDays);
        this.deliverSaturday = d.deliverSaturday === 'true';
        this.holidays = new Set((d.holidays || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
        this.html = this.querySelector('template')?.innerHTML || '';

        this.scheduled = false;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.timer = setInterval(() => this.apply(true), 60000);
        this.apply();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearInterval(this.timer);
      }

      schedule() {
        if (this.scheduled) return;
        this.scheduled = true;
        requestAnimationFrame(() => {
          this.scheduled = false;
          this.apply();
        });
      }

      /** Pone el bloque en cada nota de impuestos del carrito (lateral y página) */
      apply(refresh = false) {
        const text = this.etaText();
        document.querySelectorAll('.cart-totals__tax-note').forEach((note) => {
          let box = note.querySelector(':scope > .h433-trust');
          if (!box) {
            note.insertAdjacentHTML('beforeend', this.html);
            box = note.querySelector(':scope > .h433-trust');
          }
          const eta = box?.querySelector('[data-eta]');
          if (eta && text && (refresh || eta.innerHTML !== text)) eta.innerHTML = text;
        });
      }

      cutoff(date) {
        if (this.holidays.has(iso(date))) return null;
        const day = weekday(date);
        if (day === 0) return null;
        if (day === 6) return this.shipSaturday ? this.cutoffSat : null;
        return this.cutoffWeek;
      }

      isDeliveryDay(date) {
        if (this.holidays.has(iso(date))) return false;
        const day = weekday(date);
        if (day === 0) return false;
        if (day === 6) return this.deliverSaturday;
        return true;
      }

      addDeliveryDays(date, days) {
        let current = date;
        let count = 0;
        while (count < days) {
          current += DAY;
          if (this.isDeliveryDay(current)) count++;
        }
        return current;
      }

      /** "Pide hoy y llega entre el miércoles 4 y el lunes 9 de noviembre" */
      etaText() {
        const template = this.dataset.etaText;
        if (!template) return '';
        const now = nowInMexico();
        let ship = now.date;
        const todayCutoff = this.cutoff(ship);
        if (todayCutoff === null || now.minutes >= todayCutoff) {
          do {
            ship += DAY;
          } while (this.cutoff(ship) === null);
        }
        const first = this.addDeliveryDays(ship, this.minDays);
        const last = this.addDeliveryDays(ship, this.maxDays);
        let range;
        if (first === last) {
          range = `el <strong>${dayName(first)} de ${monthName(first)}</strong>`;
        } else if (new Date(first).getUTCMonth() === new Date(last).getUTCMonth()) {
          range = `entre el <strong>${dayName(first)}</strong> y el <strong>${dayName(last)} de ${monthName(last)}</strong>`;
        } else {
          range = `entre el <strong>${dayName(first)} de ${monthName(first)}</strong> y el <strong>${dayName(last)} de ${monthName(last)}</strong>`;
        }
        return template.replace('[rango]', range);
      }
    }

    customElements.define('h433-cart-trust', H433CartTrust);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h433-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('h433-recommendations')) {
    customElements.define(
      'h433-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.querySelector('.h433-products__grid') || !this.dataset.url || this.loading) return;
          this.loading = true;
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const fresh = html.querySelector('h433-recommendations');
              if (fresh && fresh.innerHTML.trim().length) {
                this.innerHTML = fresh.innerHTML;
              } else {
                this.closest('.shopify-section')?.classList.add('h433-recs--empty');
              }
            })
            .catch((error) => console.error(error));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-433-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('h433-gallery')) {
    customElements.define(
      'h433-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          if (!this.track || this.dots.length < 2) return;

          this.dots.forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              const i = Number(dot.dataset.dot);
              this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
            });
          });

          let frame;
          this.track.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(frame);
              frame = requestAnimationFrame(() => {
                const i = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
                this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
              });
            },
            { passive: true }
          );
        }
      }
    );
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.h433-filter[open]').forEach((d) => {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-433-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('h433-gallery')) {
    customElements.define(
      'h433-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          if (!this.track || this.dots.length < 2) return;

          this.dots.forEach((dot) => {
            dot.addEventListener('click', (event) => {
              event.preventDefault();
              const i = Number(dot.dataset.dot);
              this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
            });
          });

          let frame;
          this.track.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(frame);
              frame = requestAnimationFrame(() => {
                const i = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
                this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
              });
            },
            { passive: true }
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Los botones de la landing apuntan a #comprar. Asigna ese id a la sección
    // nativa de producto del tema (product-information) sin modificarla.
    const setAnchor = () => {
      if (document.getElementById('comprar')) return;
      const target = document.querySelector('.product-information');
      if (target) target.id = 'comprar';
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setAnchor);
    } else {
      setAnchor();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-upsell')) return;

    class ProductUpsell extends HTMLElement {
      connectedCallback() {
        this.html = this.querySelector('template[data-upsell]')?.innerHTML || '';
        this.added = new Set();
        this.observer = new MutationObserver(() => this.mount());
        this.observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', this.onClick);
        this.mount();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('click', this.onClick);
      }

      /** Coloca el upsell junto a los botones de compra nativos del producto */
      mount() {
        const anchor = document.querySelector('.product-information .buy-buttons-block');
        if (!anchor || !this.html) return;
        const parent = anchor.parentElement;
        if (parent.querySelector(':scope > .product-upsell')) return;

        const holder = document.createElement('div');
        holder.innerHTML = this.html.trim();
        const node = holder.firstElementChild;
        if (!node || !node.querySelector('.product-upsell__item')) return;

        node.querySelectorAll('[data-add]').forEach((button) => {
          if (this.added.has(this.keyFor(button))) this.markAdded(button);
        });

        if (this.dataset.position === 'before') anchor.before(node);
        else anchor.after(node);
      }

      keyFor(button) {
        return button.closest('.product-upsell__item')?.querySelector('.product-upsell__name')?.getAttribute('href') || '';
      }

      markAdded(button) {
        button.classList.add('is-added');
        button.textContent = this.dataset.added || '✓ Agregado';
        button.setAttribute('aria-disabled', 'true');
      }

      onClick = async (event) => {
        const button = event.target.closest('.product-upsell [data-add]');
        if (!button || button.getAttribute('aria-busy') === 'true' || button.classList.contains('is-added')) return;
        const item = button.closest('.product-upsell__item');
        const variantId = item?.querySelector('[data-variant]')?.value;
        if (!variantId) return;

        button.setAttribute('aria-busy', 'true');
        item.querySelector('.product-upsell__error')?.remove();
        const root = window.Shopify?.routes?.root || '/';
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

          const cart = await fetch(`${root}cart.js`).then((r) => r.json());
          this.added.add(this.keyFor(button));
          button.removeAttribute('aria-busy');
          this.markAdded(button);

          const { CartAddEvent } = await import('@theme/events');
          document.dispatchEvent(
            new CartAddEvent({}, 'product-upsell', {
              source: 'product-upsell',
              itemCount: cart.item_count,
              sections: data.sections,
            })
          );
        } catch (error) {
          const p = document.createElement('p');
          p.className = 'product-upsell__error';
          p.textContent = error.message || 'No se pudo agregar. Intenta de nuevo.';
          item.appendChild(p);
          button.removeAttribute('aria-busy');
        }
      };
    }

    customElements.define('product-upsell', ProductUpsell);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-countdown')) {
    customElements.define(
      'promo-countdown',
      class PromoCountdown extends HTMLElement {
        connectedCallback() {
          this.d = this.querySelector('[data-days]');
          this.dWrap = this.querySelector('[data-days-wrap]');
          this.h = this.querySelector('[data-hours]');
          this.m = this.querySelector('[data-minutes]');
          this.s = this.querySelector('[data-seconds]');
          this.clock = this.querySelector('.promo-cd__clock');
          this.expired = this.querySelector('[data-expired]');
          this.offsetMin = Math.round(parseFloat(this.dataset.offset || '-6') * 60);
          this.tick = this.tick.bind(this);
          this.tick();
          this.timer = setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        /** Hora de fin (ms UTC) según el modo elegido en el editor. */
        target(now) {
          const offsetMs = this.offsetMin * 60000;
          if (this.dataset.mode === 'fixed') {
            const [date, time] = (this.dataset.end || '').split('T');
            const [y, mo, d] = (date || '').split('-').map(Number);
            const [hh, mm] = (time || '23:59').split(':').map(Number);
            if (!y || !mo || !d) return null;
            return Date.UTC(y, mo - 1, d, hh || 0, mm || 0, 0) - offsetMs;
          }

          // Diario: se reinicia todos los días a la hora indicada (hora de la tienda).
          const resetHour = parseInt(this.dataset.resetHour || '0', 10) || 0;
          const local = new Date(now + offsetMs);
          let end = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), resetHour, 0, 0) - offsetMs;
          while (end <= now) end += 86400000;
          return end;
        }

        tick() {
          const now = Date.now();
          const end = this.target(now);
          let diff = end === null ? 0 : Math.max(0, end - now);

          if (diff <= 0) {
            clearInterval(this.timer);
            if (this.dataset.hideExpired === 'true') {
              this.hidden = true;
              return;
            }
            if (this.expired) {
              this.expired.hidden = false;
              this.clock.hidden = true;
            }
          }

          const pad = (n) => String(n).padStart(2, '0');
          const days = Math.floor(diff / 86400000);
          diff -= days * 86400000;
          const hours = Math.floor(diff / 3600000);
          diff -= hours * 3600000;
          const minutes = Math.floor(diff / 60000);
          const seconds = Math.floor((diff - minutes * 60000) / 1000);

          this.dWrap.hidden = days === 0;
          this.d.textContent = pad(days);
          this.h.textContent = pad(hours);
          this.m.textContent = pad(minutes);
          this.s.textContent = pad(seconds);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view-433"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('h433-quick-view')) {
    customElements.define(
      'h433-quick-view',
      class H433QuickView extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.q = (sel) => this.querySelector(sel);
          this.q('[data-qv-close]')?.addEventListener('click', () => this.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog?.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.close();
          });
          this.q('[data-qv-add]')?.addEventListener('click', () => this.add());
          window.h433QuickView = this;
        }

        disconnectedCallback() {
          if (window.h433QuickView === this) window.h433QuickView = null;
        }

        open(product) {
          if (!this.dialog || !product) return false;
          this.product = product;
          this.selected = (product.variants.find((v) => v.available) || product.variants[0]).options.slice();
          this.renderStatic();
          this.renderOptions();
          this.update();
          this.q('[data-qv-error]').hidden = true;
          const guide = this.q('[data-qv-guide]');
          if (guide) guide.hidden = true;
          this.dialog.showModal();
          document.documentElement.classList.add('h433-qv-lock');
          requestAnimationFrame(() => this.dialog.classList.add('is-open'));
          return true;
        }

        close() {
          if (!this.dialog?.open) return;
          this.dialog.classList.remove('is-open');
          document.documentElement.classList.remove('h433-qv-lock');
          setTimeout(() => this.dialog.close(), 220);
        }

        renderStatic() {
          const p = this.product;
          const thumbs = this.q('[data-qv-thumbs]');
          thumbs.replaceChildren();
          if (this.dataset.showImages === 'true') {
            const max = parseInt(this.dataset.maxImages || '4', 10);
            p.images.slice(0, max).forEach((src) => {
              const a = document.createElement('a');
              a.href = p.url;
              a.className = 'h433-qv__thumb';
              const img = document.createElement('img');
              img.src = src;
              img.alt = p.title;
              img.loading = 'lazy';
              a.appendChild(img);
              thumbs.appendChild(a);
            });
          }
          thumbs.hidden = !thumbs.children.length;
          this.q('[data-qv-title]').textContent = p.title;
          const details = this.q('[data-qv-details]');
          if (details) details.href = p.url;
        }

        renderOptions() {
          const p = this.product;
          const wrap = this.q('[data-qv-options]');
          wrap.replaceChildren();
          if (p.has_only_default_variant) return;

          p.options.forEach((name, index) => {
            const group = document.createElement('div');
            group.className = 'h433-qv__group';

            const head = document.createElement('div');
            head.className = 'h433-qv__group-head';
            const label = document.createElement('span');
            label.className = 'h433-qv__label';
            label.append(name + ' ');
            const value = document.createElement('strong');
            value.dataset.qvValue = index;
            label.appendChild(value);
            head.appendChild(label);

            if (index === 0) {
              const ship = this.q('template[data-qv-ship]')?.content.cloneNode(true);
              if (ship && ship.childElementCount) label.appendChild(ship);
              const guide = this.q('template[data-qv-guide-link]')?.content.cloneNode(true);
              if (guide && guide.childElementCount) {
                head.appendChild(guide);
                head.querySelector('[data-qv-guide-toggle]')?.addEventListener('click', () => {
                  const box = this.q('[data-qv-guide]');
                  if (box) box.hidden = !box.hidden;
                });
              }
            }
            group.appendChild(head);

            const chips = document.createElement('div');
            chips.className = 'h433-qv__chips';
            const values = [];
            p.variants.forEach((v) => {
              if (!values.includes(v.options[index])) values.push(v.options[index]);
            });
            values.forEach((val) => {
              const chip = document.createElement('button');
              chip.type = 'button';
              chip.className = 'h433-qv__chip';
              chip.textContent = val;
              chip.dataset.index = index;
              chip.dataset.value = val;
              chip.addEventListener('click', () => {
                this.selected[index] = val;
                this.update();
              });
              chips.appendChild(chip);
            });
            group.appendChild(chips);
            wrap.appendChild(group);
          });
        }

        currentVariant() {
          return this.product.variants.find((v) => v.options.every((o, i) => o === this.selected[i]));
        }

        update() {
          const p = this.product;
          const variant = this.currentVariant();

          this.querySelectorAll('.h433-qv__chip').forEach((chip) => {
            const i = Number(chip.dataset.index);
            const isSelected = this.selected[i] === chip.dataset.value;
            chip.classList.toggle('is-selected', isSelected);
            chip.setAttribute('aria-pressed', String(isSelected));
            const probe = this.selected.slice();
            probe[i] = chip.dataset.value;
            const match = p.variants.find((v) => v.options.every((o, k) => o === probe[k]));
            chip.classList.toggle('is-unavailable', !match || !match.available);
          });
          this.querySelectorAll('[data-qv-value]').forEach((el) => {
            el.textContent = this.selected[Number(el.dataset.qvValue)] || '';
          });

          const price = this.q('[data-qv-price]');
          const compare = this.q('[data-qv-compare]');
          price.textContent = variant ? variant.price : p.price;
          const showCompare = this.dataset.showCompare === 'true' && variant && variant.compare;
          compare.hidden = !showCompare;
          compare.textContent = showCompare ? variant.compare : '';
          price.classList.toggle('is-sale', Boolean(showCompare));

          const stock = this.q('[data-qv-stock]');
          if (stock) {
            const threshold = parseInt(this.dataset.stockThreshold || '5', 10);
            stock.hidden = !(variant && variant.available && variant.tracked && variant.qty > 0 && variant.qty <= threshold);
          }

          const add = this.q('[data-qv-add]');
          const available = Boolean(variant && variant.available);
          add.disabled = !available;
          add.textContent = available ? this.dataset.labelAdd : this.dataset.labelSoldout;
        }

        sectionIds() {
          return Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
        }

        async add() {
          const variant = this.currentVariant();
          if (!variant || !variant.available || this.busy) return;
          this.busy = true;
          const add = this.q('[data-qv-add]');
          const error = this.q('[data-qv-error]');
          error.hidden = true;
          add.disabled = true;
          add.textContent = this.dataset.labelAdding;

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const sections = this.sectionIds();

          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(variant.id), quantity: 1 }],
                ...(sections.length ? { sections: sections.join(',') } : {}),
              }),
            });
            const data = await response.json();
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'No se pudo agregar');
            }

            add.textContent = this.dataset.labelAdded;
            add.classList.add('is-added');

            setTimeout(() => {
              this.close();
              const event = new Event('cart:update', { bubbles: true });
              event.detail = {
                resource: {},
                sourceId: String(variant.id),
                data: {
                  source: 'h433-quick-view',
                  itemCount: 1,
                  productId: String(this.product.id),
                  variantId: String(variant.id),
                  sections: data.sections || {},
                },
              };
              document.dispatchEvent(event);
              add.classList.remove('is-added');
              this.update();
            }, 600);
          } catch (err) {
            error.textContent = err.message;
            error.hidden = false;
            this.update();
          } finally {
            this.busy = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
